import { IconBell } from 'src/Components/shared/Icon'
import styles from './BellIcon.module.scss'

export const BellIcon = () => (
  <div className={styles.bellContainer} data-qa='bell-icon'>
    <div className={styles.bellWrapper}>
      <IconBell className={styles.bell} />
    </div>
    <div className={styles.circle} />
  </div>
)
